import React from 'react';
import BodyMiddle from './components/Body/BodyMiddle';
import Footer from './components/Footer/Footer';
import LandingHeader from './components/Header/LandingHeader';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const QrMarks = () => {
    const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY ?? '';
    const content = (
        <div className='body-qr-landing'>
            <LandingHeader />
            <BodyMiddle />
            <Footer />
        </div>
    );

    // Если ключа нет, рендерим без провайдера, чтобы избежать ошибок загрузки reCAPTCHA
    if (!recaptchaKey) {
        return content;
    }

    return (
        <GoogleReCaptchaProvider reCaptchaKey={recaptchaKey}>
            {content}
        </GoogleReCaptchaProvider>
    );
};

export default QrMarks;